module.exports = __webpack_public_path__ + "img/joel-display.bc01ba37.jpg";